module.exports = __webpack_public_path__ + "static/media/stab.d97c0f96.wav";